import { createTheme, PartialTheme } from "@fluentui/react";
import { Theme as ThemeV9, webLightTheme } from "@fluentui/react-components";
import { pcpComponentsLightTheme } from "../pcpComponentsTheme";
import { createV9Theme } from "./v9ThemeShim";
import { pcpTokensValues, PcpTokens } from "./pcpTokens";

/** Theme v9 (from @fluentui) and custom tokens. https://react.fluentui.dev/?path=/docs/concepts-developer-theming--docs */
type CustomTheme = ThemeV9 & PcpTokens;

const createV9ThemeWithTokens = (theme: PartialTheme): CustomTheme => ({
    ...createV9Theme(createTheme(theme)),
    ...pcpTokensValues,
});

/**
 * pcp theme (or @fluentui default theme)
 */
export const pcpComponentsLightThemeV9: CustomTheme = createV9ThemeWithTokens(pcpComponentsLightTheme);
